import urlEncode from './urlEncode';

export default urlEncode;
